// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__2hPDE","header":"Messages_header__3kv0U"};